module.exports = __webpack_public_path__ + "img/jiker.com-tp.green-logo.81360a38.png";